import { render } from "./CustomerSwitch.vue?vue&type=template&id=379f069f"
import script from "./CustomerSwitch.vue?vue&type=script&lang=js"
export * from "./CustomerSwitch.vue?vue&type=script&lang=js"

import "./CustomerSwitch.vue?vue&type=style&index=0&id=379f069f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__